import { rem } from 'polished';

const remify = (str: string): string => {
  return str
    .split(/[ ,]+/)
    .map(item => rem(item))
    .join(' ');
};

export default remify;
